import { render } from "./AtorModal.vue?vue&type=template&id=459f5b54&scoped=true"
import script from "./AtorModal.vue?vue&type=script&lang=js"
export * from "./AtorModal.vue?vue&type=script&lang=js"

import "./AtorModal.vue?vue&type=style&index=0&id=459f5b54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-459f5b54"]])

export default __exports__